/**
 * @fileoverview GET handler for the "/data_objects/data_object_types" endpoint.
 * Returns every non-deleted custom object type definition in the workspace.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsCustomObjectTypes } from "./constants";
import type { GetCustomObjectsCustomObjectTypesParams, GetCustomObjectsCustomObjectTypesResult } from "./types";
import { isGetCustomObjectsCustomObjectTypesResult } from "./validators";

export const getCustomObjectsCustomObjectTypes = reactQueryFetcherAdapter(
  customObjectsCustomObjectTypes,
  (
    signal: AbortSignal,
    params: GetCustomObjectsCustomObjectTypesParams
  ): Promise<GetCustomObjectsCustomObjectTypesResult> => {
    return fetch(
      customObjectsCustomObjectTypes,
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsCustomObjectTypesResult
);
